export const planReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_SUBSCRIPTION_LIST_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GET_SUBSCRIPTION_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        planList: action.payload,
      };

    case "GET_SUBSCRIPTION_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
